import { router, Stack, useLocalSearchParams } from 'expo-router';
import * as React from 'react';
import { ActivityIndicator, View } from 'react-native';

import { EventForm, type EventEditorCommunity } from '@/components/events/event-form';
import { useSession } from '@/components/session-provider';
import { useTenant } from '@/components/tenant-provider';
import { adminTenantsForUser } from '@/lib/tenant';

export default function AdminGlobalNewEventScreen() {
  const { tenant: requestedTenant } = useLocalSearchParams<{ tenant?: string }>();
  const { isAdmin, isProfileLoading } = useSession();
  const { isTenantLoading, memberships, tenants } = useTenant();

  const communities = React.useMemo<EventEditorCommunity[]>(
    () =>
      adminTenantsForUser(tenants, memberships, isAdmin).map(({ id, name, slug }) => ({
        id,
        name,
        slug,
      })),
    [isAdmin, memberships, tenants]
  );
  const [selectedTenantId, setSelectedTenantId] = React.useState<string | null>(null);
  const requestedCommunity = communities.find((community) => community.slug === requestedTenant);
  const effectiveTenantId =
    selectedTenantId ??
    requestedCommunity?.id ??
    (communities.length === 1 ? communities[0].id : null);
  const selectedCommunity =
    communities.find((community) => community.id === effectiveTenantId) ?? null;

  function selectTenant(tenantId: string) {
    const community = communities.find((item) => item.id === tenantId);
    setSelectedTenantId(tenantId);
    if (community) {
      router.setParams({ tenant: community.slug });
    }
  }

  if (isProfileLoading || isTenantLoading) {
    return (
      <View className="flex-1 items-center justify-center bg-background">
        <Stack.Screen options={{ headerShown: false }} />
        <ActivityIndicator />
      </View>
    );
  }

  return (
    <EventForm
      communities={communities}
      onClose={() => router.back()}
      onSaved={(savedEvent) => {
        router.replace({
          pathname: '/app/events/[id]',
          params: { id: savedEvent.id },
        });
      }}
      onTenantChange={selectTenant}
      tenantId={selectedCommunity?.id ?? null}
      tenantName={selectedCommunity?.name ?? null}
      tenantSlug={selectedCommunity?.slug ?? null}
    />
  );
}
